import { captureException } from '@sentry/react';
import { QueryClient, MutationCache } from '@tanstack/react-query';

import { STALE_TIMES } from './queryConstants';
import { useErrorStore } from './stores/errorStore';

export const queryClient = new QueryClient({
	mutationCache: new MutationCache({
		onError: (error, _variables, _context, mutation) => {
			if (mutation.options.meta?.suppressGlobalError) return;
			useErrorStore.getState().showError({ error });
			captureException(error, {
				tags: { mutation: mutation.options.mutationKey?.join('.') ?? 'unknown' },
				level: 'error',
			});
		},
	}),
	defaultOptions: {
		queries: {
			retry: (failureCount, error) => {
				// Don't retry on 4xx errors (client errors)
				if (error?.status >= 400 && error?.status < 500) {
					return false;
				}
				// Retry up to 3 times for other errors
				return failureCount < 3;
			},
			staleTime: STALE_TIMES.STANDARD,
			refetchOnWindowFocus: false,
			// Don't throw errors on the UI level by default
			throwOnError: false,
		},
		mutations: {
			// Don't throw errors on the UI level by default for mutations
			throwOnError: false,
		},
	},
});
